export default __webpack_public_path__ + "static/media/bag.73ab62e8.svg";